import React from 'react';
import { connect } from 'react-redux';
import WhatIfTreeGridPres from '../presentational/WhatIfTreeGridPres';
import intl from 'react-intl-universal';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';

const mod = (x, n) => ((x % n) + n) % n;
class WhatIfTreeGridContainer extends React.Component {
  componentDidMount() {
    this.setState({
      tableData: this.getTableData(),
    });
  }

  createTreeColumns() {
    const treeColumns = [
      { name: 'columns', title: ' ' },
      ...this.props.data.map(result => {
        const numEmployees = result.numEmployees;
        return {
          name: 'type' + result.id,
          title: (
            <div
              className="whatif-treegrid-header"
              style={{ backgroundColor: this.props.colors[mod(result.id, this.props.colors.length)] }}>
              <Typography className="whatif-treegrid-header-text wordwrap">
                {numEmployees > 1 ? numEmployees + ' x ' + result.type : result.type}
              </Typography>
            </div>
          ),
        };
      }),
    ];

    return treeColumns;
  }

  getColumnsAtLevel(level, data) {
    let columns = Object.keys(data[0]);
    columns = columns.filter(column => {
      if (level === 1) {
        return (
          column !== 'selected' &&
          column !== 'id' &&
          column !== 'type' &&
          column !== 'numEmployees' &&
          column !== 'totalCompensationWithEmployees' &&
          column !== 'outputCurrency' &&
          column !== 'homeAssumptions' &&
          column !== 'hostAssumptions' &&
          column !== 'immigrationNotes' &&
          column !== 'key'
        );
      } else if (level === 2) {
        return column !== 'total' && column !== 'outputCurrency' && column !== 'key';
      } else {
        return column !== 'total' && column !== 'outputCurrency' && column !== 'key';
      }
    });

    return columns;
  }

  createTreeRowsHelper(level, treeColumns, data) {
    let tableHeaders = intl.get('whatif.calculator.tableHeaders');
    const selectedResults = data;
    let columns = this.getColumnsAtLevel(level, data);

    let treeRows = [];
    columns.forEach(
      function(column) {
        let row = {};
        row['columns'] = <Typography className="whatif-treegrid-column-text wordwrap">{tableHeaders[column]}</Typography>;
        let index = 1;
        let showRow = false;
        selectedResults.forEach(
          function(result) {
            const numEmployees = result.numEmployees;
            const isObject = typeof result[column] === 'object';
            let val = isObject ? result[column].total : result[column];
            const isNumber = typeof val === 'number';
            let currency = result.outputCurrency;
            val =
              isNumber && val !== 0 ? (
                <CurrencyFormat
                  value={val}
                  displayType={'text'}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={intl.get('whatif.calculator.currency.prefix')[currency]}
                  suffix={intl.get('whatif.calculator.currency.suffix')[currency]}
                  renderText={value => <div>{numEmployees > 1 ? numEmployees + ' x ' + value : value}</div>}
                />
              ) : (
                val
              );

            row[treeColumns[index++].name] = <Typography className="whatif-treegrid-cell-text wordwrap">{val}</Typography>;
            if (val) {
              showRow = true;
              if (isObject) {
                var childColumnData = selectedResults.map(result => {
                  return { ...result[column], outputCurrency: result.outputCurrency };
                });

                row.items = this.createTreeRowsHelper(level + 1, treeColumns, childColumnData);
              }
            }
          }.bind(this),
        );
        if (showRow) treeRows.push(row);
      }.bind(this),
    );

    return treeRows;
  }

  createTreeRows(treeColumns, data) {
    return this.createTreeRowsHelper(1, treeColumns, data, null);
  }

  getTableData = () => {
    let treeColumns = this.createTreeColumns();
    let treeRows = this.createTreeRows(treeColumns, this.props.data);
    let tableColumnExtensions = [{ columnName: 'columns', width: 300 }];
    let stickyLeftColumn = ['columns'];
    return { treeColumns, treeRows, tableColumnExtensions, stickyLeftColumn };
  };

  render() {
    return <WhatIfTreeGridPres {...this.props} {...this.state} />;
  }
}

const mapStateToProps = state => ({
  colors: state.whatIf.colors,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfTreeGridContainer);
